var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { on: { mouseenter: _vm.mostrarCompletoSiCortado } },
    _vm._l(_vm.partes, function (parte, indice) {
      return _c(
        "span",
        { key: indice, class: { "fw-semibold": parte.coincide } },
        [_vm._v(_vm._s(parte.texto))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }